<template>
  <ZMainPage type="card" v-loading="loading">
    <div class="z-box-bg top-info">
      <div class="top-info-item" v-for="item in list" :key="item.label">
        <div class="top-info-label">{{ item.label }}</div>
        <div class="top-info-value">{{ item.value }}</div>
      </div>
    </div>
    <div class="z-box-bg p-4">
      <DynamicForm ref="dynamicDom" :list="formConfig" labelWidth="165rem"></DynamicForm>
    </div>
    <template #footer>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
      <el-button @click="handleBack">取消</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import DynamicForm from "@/components/common/DynamicForm"
import { changeOption, setConfigOption } from "@/utils"
import { zsPost, zsGet, get_recruit_dict } from '@/api'
import { formDataBackMixin } from '@/utils/mixins'
export default {
	_config:{"route":{"path":"edit","meta":{"title":"编辑"}}},
  components: { DynamicForm },
  mixins: [formDataBackMixin],
  data() {
    return {
      loading: false,
      student_status: '',
      list: [],
      formConfig: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      zsGet('/recruit/fresh-graduate/show-v2', { order_id: this.$route.query.id }).then(res => {
        this.list = [
          { label: '学生姓名', value: res.student_name },
          { label: '性别', value: res.sex || '-' },
          { label: '家长姓名', value: res.parent_name || '-' },
          { label: '家长和学生的关系', value: res.relationship_name || '-' },
        ]
        const student_status = res.student_status === -1 ? '' : res.student_status
        this.student_status = student_status || ''

        this.formConfig = [
          { label: '正式报名实际就读学校', prop: 'study_school_id', tag: 'select', value: res.study_school_id, span: 8, options: [] },
          { label: '学生所属业务线', prop: 'business_type', tag: 'select', value: res.business_type, span: 8, options: [] },
          { label: '修改学生状态', prop: 'student_status', span: 8, tag: 'select', value: student_status, span: 8, options: [] },
          { label: '家长银行账户', prop: 'parent_bank', maxlength: 30, value: res.parent_bank, span: 8 },
          { label: '开户行', prop: 'bank_name', maxlength: 30, value: res.bank_name, span: 8 },
          { label: '开户人', prop: 'bank_user', maxlength: 16, value: res.bank_user, span: 8 },
          { label: '备注信息', prop: 'content', maxlength: 100, isSingle: true, type: 'textarea', span: 22, custom: { autosize: { minRows: 3, maxRows: 4 }, showWordLimit: true } }
        ]
        get_recruit_dict().then(res => {
          setConfigOption({ list: this.formConfig, data: res.repeat_business_line, key: 'business_type' })
        })
        // 实际就读学校 学籍所属学校
        zsGet('/recruit/common/consulting-school', { order_id: this.$route.query.id }).then(res => {
          const { entity_school = [] } = res
          const list = changeOption({list: entity_school, label: 'school_name', value: 'id'})
          setConfigOption({ list: this.formConfig, data: list, key: 'study_school_id' })
        })

        // 学生状态
        zsGet('/recruit/fresh-graduate/student-status').then(data => {
          let list = Object.keys(data).map(item => ({ label: data[item], value: Number(item) })).filter(item =>  [1,4].includes(item.value))
          setConfigOption({ list: this.formConfig, data: list, key: 'student_status' })
        })
      }).finally(() => this.loading = false)
    },
    handleSubmit() {
      this.$refs.dynamicDom.validate().then((form) => {
        const data = { ...form, order_id: this.$route.query.id }
        this.loading = true
        zsPost('/recruit/fresh-graduate/update-anew-v3', data).then(() => {
          this.$message.success('操作成功')
          this.$router.go(-1)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    handleBack() {
      this.formBack({a:1})
    }
  }
}
</script>


<style lang="scss" scoped>
.top-info {
  border-bottom: solid 20rem #f7f7f7;
  display: flex;
  &-item {
    margin-right: 130rem;
    font-size: 16rem;
    display: flex;
  }
  &-label {
    margin-right: 30rem;
  }
  &-value {
    font-weight: 600;
  }
}
</style>
